import UpdatePage from './UpdatePage';

export default UpdatePage;
